import {hasSomePermission} from '../../../forecast-app/shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../../Permissions';

export const theEyeOptionsNoGrouping = [
	{
		name: 'task',
		checked: true,
		translationId: null,
		hide: true,
		nestedOptions: null,
	},
	{
		name: 'taskDates',
		checked: false,
		translationId: 'common.task_dates',
		nestedOptions: [
			{
				name: 'startDate',
				checked: false,
				translationId: 'common.start_date',
				nestedOptions: null,
			},
			{
				name: 'deadline',
				checked: false,
				translationId: 'common.deadline',
				nestedOptions: null,
			},
		],
	},
	{
		name: 'project',
		checked: true,
		translationId: 'common.project',
		nestedOptions: null,
	},
	{
		name: 'projectDeadline',
		checked: false,
		translationId: 'insights.component.list.column.projectDeadline',
		nestedOptions: null,
	},
	{
		name: 'projectStage',
		checked: false,
		translationId: 'insights.component.list.column.projectStage',
		nestedOptions: null,
	},
	{
		name: 'clientName',
		checked: true,
		translationId: 'common.client',
		nestedOptions: null,
	},
	{
		name: 'status',
		checked: true,
		translationId: 'common.status',
		nestedOptions: null,
	},
	{
		name: 'roleName',
		checked: true,
		translationId: 'common.role',
		nestedOptions: null,
	},
	{
		name: 'assignees',
		checked: true,
		translationId: 'common.assignees',
		hide: true,
		nestedOptions: null,
	},
	{
		name: 'phase',
		checked: true,
		translationId: 'common.milestone',
		nestedOptions: null,
	},
	{
		name: 'phaseDates',
		checked: false,
		translationId: 'common.phase_dates',
		nestedOptions: [
			{
				name: 'startDate',
				checked: false,
				translationId: 'common.start_date',
				nestedOptions: null,
			},
			{
				name: 'deadline',
				checked: false,
				translationId: 'common.deadline',
				nestedOptions: null,
			},
		],
	},
	{
		name: 'sprint',
		checked: true,
		translationId: 'common.sprint',
		nestedOptions: null,
	},
	{
		name: 'sprintDates',
		checked: false,
		translationId: 'common.sprint_dates',
		nestedOptions: [
			{
				name: 'startDate',
				checked: false,
				translationId: 'common.start_date',
				nestedOptions: null,
			},
			{
				name: 'deadline',
				checked: false,
				translationId: 'common.deadline',
				nestedOptions: null,
			},
		],
	},
	{
		name: 'work',
		checked: true,
		disabled: false,
		translationId: 'common.work',
		nestedOptions: [
			{
				name: 'estimate',
				checked: true,
				disabled: false,
				translationId: 'common.estimate',
				nestedOptions: [
					{
						name: 'hours',
						checked: true,
						disabled: false,
						translationId: 'common.hours',
						nestedOptions: null
					},
					{
						name: 'points',
						checked: false,
						disabled: false,
						translationId: 'common.points',
						nestedOptions: null
					}
				]
			},
			{
				name: 'remaining',
				checked: true,
				disabled: false,
				translationId: 'common.remaining',
				nestedOptions: [
					{
						name: 'hours',
						checked: true,
						disabled: false,
						translationId: 'common.hours',
						nestedOptions: null
					},
					{
						name: 'points',
						checked: false,
						disabled: false,
						translationId: 'common.points',
						nestedOptions: null
					}
				]
			},
			{
				name: 'difference',
				checked: false,
				disabled: false,
				translationId: 'common.difference',
				nestedOptions: [
					{
						name: 'hours',
						checked: false,
						disabled: false,
						translationId: 'common.hours',
						nestedOptions: null
					},
					{
						name: 'points',
						checked: false,
						disabled: false,
						translationId: 'common.points',
						nestedOptions: null
					}
				]
			},
		],
	},
	{
		name: 'reported',
		checked: true,
		translationId: 'common.reported',
		nestedOptions: [
			{
				name: 'reportedTime',
				checked: true,
				translationId: 'common.time_entries',
				nestedOptions: null,
			},
			{
				name: 'projected',
				checked: true,
				translationId: 'common.projected',
				nestedOptions: null,
			},
		],
	},
	{
		name: 'progress',
		checked: true,
		translationId: 'common.progress',
		nestedOptions: null,
	},
	{
		name: 'rateCard',
		checked: false,
		translationId: 'common.rate-card',
		nestedOptions: null,
	},

	{
		name: 'plannedRevenue',
		translationId: 'project_budget.planned_revenue',
		checked: true,
		nestedOptions: null,
	},
	{
		name: 'actualRevenue',
		translationId: 'project_budget.actual_revenue',
		checked: true,
		nestedOptions: null,
	},
	{
		name: 'indicators',
		translationId: 'common.indicators',
		checked: true,
		nestedOptions: null,
	},
	{
		name: 'approved',
		translationId: 'common.approved',
		checked: true,
		nestedOptions: null,
	},
	{
		name: 'labels',
		translationId: 'common.labels',
		checked: false,
		nestedOptions: null,
	},
];

export const theEyeOptionsByGrouping = (initialEyeOptions, firstGrouping) => {
	let currentEyeOptions = [...initialEyeOptions];
	if (firstGrouping !== null) {
		currentEyeOptions.unshift(
			{
				name: 'caretIcon',
				checked: true,
				translationId: null,
				hide: true,
			},
			{
				name: 'mainItem',
				checked: true,
				translationId: null,
				hide: true,
			}
		);
	}
	return currentEyeOptions;
};

export const filterObjectEyeOptions = initialEyeOptions => {
	const financialFields = ['actualRevenue', 'plannedRevenue'];
	const filteredEyeOptions = {...initialEyeOptions};
	if (!(hasSomePermission([PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION, PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION_REVENUE]))) {
		financialFields.forEach(field => {
			delete filteredEyeOptions[field];
		});
	}
	return filteredEyeOptions;
};
export const theEyeOptionsFiltered = initialEyeOptions => {
	const financialFields = ['actualRevenue', 'plannedRevenue'];

	const financialFieldFilter = item => {
		if (!(hasSomePermission([PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION, PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION_REVENUE]))) {
			return !financialFields.includes(item.name);
		}
		return true;
	};

	const currentEyeOptions = [...initialEyeOptions];
	return currentEyeOptions.filter(financialFieldFilter);
};
